module.exports = __webpack_public_path__ + "static/media/10a_tn.3e200717.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/10a_tn.jpg
// module id = 499
// module chunks = 0